import React, { createContext, useState, useContext, useEffect } from 'react';
import { AuthContext } from './AuthContext';
import { API_URL } from '../config';

export const WishlistContext = createContext();

export const WishlistProvider = ({ children }) => {
  const [wishlistItems, setWishlistItems] = useState([]);
  const { user, token } = useContext(AuthContext);

  useEffect(() => {
    if (user && token) {
      fetchWishlist();
    } else {
      setWishlistItems([]);
    }
  }, [user, token]);

  const fetchWishlist = async () => {
    try {
      const res = await fetch(`${API_URL}/api/wishlist`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (res.ok) {
        const data = await res.json();
        setWishlistItems(data);
      }
    } catch (err) {
      console.error('Failed to fetch wishlist', err);
    }
  };

  const addToWishlist = async (productId, productData) => {
    if (!user) {
      // Could potentially redirect to login or show a toast
      alert("Please log in to add items to your wishlist.");
      return;
    }
    
    // Optimistic update
    if (!wishlistItems.find(item => item.product_id === productId)) {
      setWishlistItems([...wishlistItems, { product_id: productId, ...productData }]);
    }

    try {
      await fetch(`${API_URL}/api/wishlist`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ productId })
      });
      // Optionally refetch to ensure consistency
    } catch (err) {
      console.error('Failed to add to wishlist', err);
    }
  };

  const removeFromWishlist = async (productId) => {
    if (!user) return;

    // Optimistic update
    setWishlistItems(wishlistItems.filter(item => item.product_id !== productId));

    try {
      await fetch(`${API_URL}/api/wishlist/${productId}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` }
      });
    } catch (err) {
      console.error('Failed to remove from wishlist', err);
    }
  };

  const isInWishlist = (productId) => {
    return wishlistItems.some(item => item.product_id === productId);
  };

  return (
    <WishlistContext.Provider value={{ wishlistItems, addToWishlist, removeFromWishlist, isInWishlist }}>
      {children}
    </WishlistContext.Provider>
  );
};
